import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styles from "./TestimonialSlider.module.css";
import { gettestimonial } from "../../../Services/APIrequests";
import PlaceholderImage from "../../../Assets/defaultimg.png";
import { TfiQuoteRight } from "react-icons/tfi";
import parse from "html-react-parser";

const TestimonialSlider = ({ id }) => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await gettestimonial();
        const data = response?.data?.testimonials || [];
        const activeTestimonials = data.filter(
          (testimonial) => testimonial.status === "ACTIVE"
        );
        setTestimonials(activeTestimonials);
      } catch (err) {
        console.error("Failed to fetch testimonials", err);
      }
    };

    fetchTestimonials();
  }, []);

  const getSliderSettings = () => {
  const count = testimonials.length;

  return {
    dots: true,
    infinite: count > 1,
    speed: 500,
    slidesToShow: Math.min(3, count), // show up to 3 by default
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(2, count), // show 2 on medium screens
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // show 1 on small screens
        },
      },
    ],
  };
};


  return (
    <div className={styles.container} id={id}>
      <h2 className={styles.title}>Testimonials</h2>
      {testimonials.length > 0 ? (
        <Slider {...getSliderSettings()}>
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className={styles.card}
              style={{ backgroundColor: testimonial.bgColor || "#fff" }}
            >
              <div className={styles.testimonial_img_container}>
                <img
                  src={testimonial.imageUrl || PlaceholderImage}
                  alt={testimonial.name}
                  className={styles.profileImg}
                />
                <TfiQuoteRight className={styles.quoteIcon} />
              </div>

              <div className={styles.textContainer}>
                <div className={styles.quote}>
                  {typeof testimonial.description === "string"
                    ? parse(testimonial.description)
                    : testimonial.description}
                </div>
                <span className={styles.name}>{testimonial.name}</span>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <p>No testimonials available.</p>
      )}
    </div>
  );
};

export default TestimonialSlider;
